import React from "react";
import DropZone from "../../../components/DropZone";
import {getSupportedResourcesFormats} from "../../../common";
import RenderFile from "../RenderFile";
import {Trans, withTranslation} from 'react-i18next';

function JobFiles(props) {
    let supported_formats = props.validation_rules && props.element_item && getSupportedResourcesFormats(props.validation_rules,props.element_item.type_id);
    const upload = (file) => {
        props.formik.setFieldValue('files',file)
    }
    const deleteFile = (id) => {
        props.deleteJobAttachment(props.job_id,id)
    }
    return(
        <div className="form-group">
            <div className={`sidebar__title sidebar__title_offset-free ${props.titleClass}`}>
                <Trans>{props.title || 'Upload visual expectation'}</Trans>
            </div>
            {props.job_attachments && <div className="d-flex flex-wrap w-100 justify-content-between mb-3">
                {props.job_attachments.map((file) => {
                    return <RenderFile data={file} showFullSizeGallery={props.showFullSizeGallery}
                                       deleteFile={deleteFile} readOnly={props.readOnly}/>
                })}
            </div>}
            {props.formik && <DropZone {...props}
                       formik={props.formik}
                       title={"Upload a file"}
                       acceptedFormats={supported_formats}
                       upload={upload}
                       classes={"w-100 mb-3"}
                       errorMessage={props.formik.errors["files"] ? props.formik.errors["files"] : undefined}
                       supported_formats={supported_formats}
                       field={props.formik.values.files}
                       maxFiles={6}/>}


        </div>
    )
}

export default withTranslation('translations')(JobFiles);
